<template>
  <article class="p-destination">
    <div class="p-destination__header" ref="header" :style="{
      height: headerHeight
    }">
      <div class="p-destination__title">
        <div v-if="post.acf.dest_icon" class="p-destination__logo u-fade">
          <img :src="post.acf.dest_icon.url" alt="">
        </div>
        <h2 class="p-destination__heading"><span class="u-mask">{{ post.acf.dest_name }}</span></h2>
        <em class="p-destination__prefecture"><span class="u-mask">{{ post.acf.dest_pref }}</span></em>
      </div>
      <!-- slider -->
      <cominca-slider 
        :images="post.acf.dest_key_images" 
        :hasPager="true" 
        :style="{
          height: sliderHeight
        }" 
        class="p-destination__slider" 
        ref="slider" />
      <!-- /slider -->
    </div>
    
    <scroll-spy ref="scrollSpy">
      <!-- wysiwyg -->
      <scroll-spy-section v-if="post.acf.modules.length" :label="`Story`">
        <div class="p-container">
          <section class="p-destination__content">
            <global-wysiwyg :post="post" />
          </section>  
        </div>
      </scroll-spy-section>
      <!-- /wysiwyg -->
      
      <!-- pickup -->
      <scroll-spy-section v-if="post.acf.pickup" :label="`Explore`">
        <section class="p-section">
          <scroll-animation-unit>
            <h2 class="c-heading u-fade">Explore {{ post.acf.dest_name }}</h2>
          </scroll-animation-unit>
          <cominca-pickup :items="post.acf.pickup" />
        </section>
      </scroll-spy-section>
      <!-- pickup -->
      
      <!-- Access -->
      <scroll-spy-section v-if="post.acf.dest_gmap" :label="`Access`">
        <div class="p-container">
          <section class="p-section">
            <scroll-animation-unit>
              <h2 class="c-heading u-fade">Access</h2>
            </scroll-animation-unit>
            <cominca-access 
              :has-routes="true" 
              :gmap="post.acf.dest_gmap" 
              :destFrom="post.acf.dest_from" />
          </section>
        </div>
      </scroll-spy-section>
      <!-- /Access -->

      <!-- Accommodation -->
      <scroll-spy-section v-if="accommodations.length" :label="`Accommodation`">
        <div class="p-container">
          <aside class="p-section" id="accommodation">
            <scroll-animation-unit>
              <h2 class="c-heading u-fade">Accommodation</h2>
            </scroll-animation-unit>
            <div>
              <accommodation-item v-for="accommodation in accommodations" :key="accommodation.ID" :post="accommodation" />
            </div>
          </aside>
        </div>
      </scroll-spy-section>
      <!-- /Accommodation -->
    </scroll-spy>

    <page-navigation :sections="sections" />
  </article>
  <!-- <article class="l-container l-dest-template">
    <h1 class="c-heading-common c-heading-common--blue">{{ model.title }}</h1>

    <div class="l-dest-template__main">
      {{ post.acf.dest_name }}    
    </div>
  </article> -->
</template>

<script>
  /**
   * Modules
   */
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import ComincaSlider from '~/partial/cominca-slider'
  import globalWysiwyg from '~/partial/global-wysiwyg'
  import PageNavigation from '~/partial/page-navigation'

  import ComincaAccess from '~/partial/cominca-access'
  import ComincaPickup from '~/partial/cominca-pickup'
  import AccommodationItem from '~/partial/accommodation-item'

  import objectFitCover from '~/mixins/object-fit-cover'
  import imageLoader from '~/mixins/image-loader'

  /**
   * Share Partial
   */


  export default {
    name: 'page-dest-template',
    mixins: [
      objectFitCover,
      imageLoader
    ],
    components: {
      ComincaSlider,
      globalWysiwyg,
      PageNavigation,
      ComincaAccess,
      ComincaPickup,
      AccommodationItem,
    },
    data () {
      return {
        type: '',
        post: {},
        model: {
          title: ''
        },
        sections: [],
        accommodations: [],
        the_id: ''
      }
    },
    computed: {
      isMobile() {
        return this.$window.viewport === 'mobile'
      },
      headerHeight() {
        return this.isMobile ? `${global.innerHeight}px` : '100vh'
      },
      sliderHeight() {
        return this.isMobile ? `calc(${global.innerHeight}px - 12rem)` : 'calc(100vh - 12rem)'
      },
      ...mapGetters({
        'getPost': 'posts/getPost',
        'getPosts': 'posts/getPosts',
        'getHeaders': 'posts/getHeaders',
        'getInfo': 'route/getInfo',
        'isCoverImageScaled': 'coverImage/isScaled',
      })
    },
    watch: {
      isCoverImageScaled(value) {
        if(!value) {
          let headerTimer = setTimeout(() => {
            this.$refs.header.classList.add('is-animated')
            clearTimeout(headerTimer)
            headerTimer = null
          }, 1200)

          let sliderTimer = setTimeout(() => {
            this.$refs.slider.start()
            clearTimeout(sliderTimer)
            sliderTimer = null
          }, 3000)
        }
      }
    },
    async beforeRouteUpdate(to, from, next) {
      if(this.the_id !== this.getInfo().the_id) {
        let id = this.getInfo().the_id

        await this.fetchPosts({ type: 'destination', id })

        await this.fetchPosts({ type: 'acc-by-dest', id })
      }

      next()
    },
    beforeRouteLeave(to, from, next) {
      this.showLoader()

      next()
    },
    created() {
      this.routing(this.getInfo());
      this.the_id = this.getInfo().the_id
    },
    mounted() {
      this.$nextTick(() => {
        this.$_imageLoader_load(this.$el).then(this.onImagesLoaded)
      })
    },
    methods: {
      routing(status={}) {
        this.type = 'destination';
        this.model.title = 'DESTINATION';
        this.post = this.getPost('destination');
        this.accommodations = this.getPosts('accommodation')
        // console.log(this.post)
        // console.log('ここです');
        // console.log(this.getPosts('accommodation'));
      },
      hideCoverImage() {
        let sliderEl = this.$refs.slider.$el
        let { width, height, top, left } = sliderEl.getBoundingClientRect()

        this.setSize({ width, height })
        this.setPosition({ top, left })

        this.$nextTick(() => {
          this.setCoverImageFixedState(false)
          // this.setCoverImageScaleState(false)

        })
      },
      onImagesLoaded() {
        
        this.$refs.scrollSpy.watch()
        this.sections = this.$refs.scrollSpy.getLabels()

        // カバー画像で覆われているとき
        if(this.isCoverImageScaled) {
          this.hideCoverImage()
        } else {
          this.$refs.slider.start()
          this.$refs.header.classList.add('is-animated')
        }

        this.hideLoader()

        
      },
      ...mapActions({
        'fetchPosts': 'posts/fetchPosts',
      }),
      ...mapMutations({
        'showLoader': 'loader/SHOW',
        'hideLoader': 'loader/HIDE',
        'setSize': 'coverImage/SET_SIZE',
        'setPosition': 'coverImage/SET_POSITION',
        'setCoverImageFixedState': 'coverImage/SET_FIXED_STATE',
        'setCoverImageScaleState': 'coverImage/SET_SCALE_STATE',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/dest_template.vue